import { Role } from "@vviinn/user-managment-client-ts";
import { UserRole } from "../types";

const companyRoles: Record<Role, UserRole> = {
  owner: "companyOwner",
  editor: "companyEditor",
  viewer: "companyViewer",
};
export const companyRoleToUserRole = (role: Role): UserRole => {
  return companyRoles[role];
};
